import styled from 'styled-components';

export const OverviewContainer = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(5, 1fr);

    @media (max-width: 768px) {
        grid-template-columns: repeat(3, 1fr);
        gap: 15px;
    }
`;
